import { MessageCircle, X } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

export const WhatsAppChat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();

  const phoneNumber = "13467057320"; // +1 (346) 705-7320 without formatting
  
  const messages = {
    en: {
      title: "Need help with pricing?",
      subtitle: "Chat with us on WhatsApp",
      button: "Start Chat",
      defaultMessage: "Hello! I'm interested in your pricing services."
    },
    es: {
      title: "¿Necesitas ayuda con precios?",
      subtitle: "Chatea con nosotros por WhatsApp",
      button: "Iniciar Chat",
      defaultMessage: "¡Hola! Estoy interesado en sus servicios de precios."
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(messages[language].defaultMessage);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <button
        onClick={() => setIsVisible(!isVisible)}
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="WhatsApp Chat"
      >
        <MessageCircle className="w-6 h-6" />
      </button>

      {/* Chat Popup */}
      {isVisible && (
        <div className="fixed bottom-24 right-6 z-50 bg-background border border-border rounded-lg shadow-xl w-80 animate-scale-in">
          {/* Header */}
          <div className="bg-[#25D366] text-white p-4 rounded-t-lg flex items-center justify-between">
            <div>
              <h3 className="font-semibold text-sm">{messages[language].title}</h3>
              <p className="text-xs opacity-90">{messages[language].subtitle}</p>
            </div>
            <button
              onClick={() => setIsVisible(false)}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Body */}
          <div className="p-4">
            <div className="bg-muted p-3 rounded-lg mb-3">
              <div className="flex items-center mb-2">
                <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center">
                  <MessageCircle className="w-4 h-4 text-white" />
                </div>
                <span className="ml-2 font-medium text-sm">PriceZing</span>
              </div>
              <p className="text-sm text-muted-foreground">
                {messages[language].defaultMessage}
              </p>
            </div>

            <button
              onClick={handleWhatsAppClick}
              className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white py-2 px-4 rounded-lg font-medium text-sm transition-colors"
            >
              {messages[language].button}
            </button>
          </div>
        </div>
      )}
    </>
  );
};